require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-deep-contextualized-word-representations-elmo.json") })
        }
      }, "path---posts-deep-contextualized-word-representations-elmo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-deep-contextualized-word-representations-elmo!./.cache/json/posts-deep-contextualized-word-representations-elmo.json
// module id = 375
// module chunks = 231608221292675